import React from 'react'

const OpenFileIcon = () => {
    return (
        <svg className='open-file-icon' data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 683.33 600">
            <defs>
                <style>
                    {`
          .cls-123 {
        fill-rule: evenodd;
      }
        `}

                </style>
            </defs>
            <path className="cls-123" d="M278.26,66.67l67.99,53.76-47.46,47.46-43.7-34.56H66.67v329.33l61.49-196h405.18,0s66.67,0,66.67,0h83.33s-101.17,333.33-101.17,333.33H0V66.67h278.26ZM593.42,333.33H177.12l-62.76,200h418.39l60.68-200Z" />
            <path d="M600,0v233.33h-66.67v-119.53s-119.53,119.53-119.53,119.53h-94.28s166.67-166.67,166.67-166.67h-119.53s0-66.67,0-66.67h233.33Z" />
        </svg>
    )
}

export default OpenFileIcon
